import commonJsModule from "has-content"

export default commonJsModule.default